export const maybeAddErrorStyle = (field, errors) => {
  const hasError = errors && errors.some(e => {
    const rootPath = e?.dataPath ? e.dataPath.substring(1) + "." : "";
    return (rootPath + e?.params?.missingProperty) === field;
  });

  return hasError ? "border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500" : "";
};
